import { Platform, StyleSheet } from 'react-native';

import { COLOR, blackTransparent } from 'utils/colors';
import {
    androidScreenMarginBottom,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        marginBottom: androidScreenMarginBottom,
    },
    button: {
        width: Platform.select({
            default: widthPercentageToDP(328, 170),
            web: 146,
        }),
    },
    buttonText: {
        color: COLOR.background,
    },
    tryAgainButtonTablet: {
        width: 'auto',
        minWidth: 120,
    },
    loaderContainer: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: blackTransparent(0.9),
        justifyContent: 'center',
        alignItems: 'center',
    },
    descriptionText: {
        textAlign: 'center',
        maxWidth: widthPercentageToDP(480),
        marginTop: 16,
        lineHeight: 24,
    },
});

export default styles;
